module.exports = __webpack_public_path__ + "static/media/video3.fb5fc29.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/video3.mp4
// module id = 5CXf
// module chunks = 0